/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Team = {
    properties: {
        officialName: {
            type: 'string',
            isRequired: true,
        },
        id: {
            type: 'number',
            isRequired: true,
        },
        name: {
            type: 'Translation',
            isRequired: true,
        },
        internalName: {
            type: 'string',
            isRequired: true,
        },
        emblem: {
            type: 'Image',
            isRequired: true,
        },
        primaryColor: {
            type: 'string',
            isRequired: true,
        },
        secondaryColor: {
            type: 'string',
            isRequired: true,
        },
        leagues: {
            type: 'array',
            contains: {
                type: 'LeagueListElement',
            },
            isRequired: true,
        },
        jerseyColor1: {
            type: 'string',
            isRequired: true,
        },
        jerseyColor2: {
            type: 'string',
            isRequired: true,
        },
        jerseyMode: {
            type: 'JerseyModeEnum',
            isRequired: true,
        },
        club: {
            type: 'any-of',
            contains: [{
                type: 'ClubListElement',
            }, {
                type: 'null',
            }],
        },
        outOfCompetition: {
            type: 'boolean',
            isRequired: true,
        },
        matchBoard: {
            type: 'any-of',
            contains: [{
                type: 'string',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
        leader: {
            type: 'any-of',
            contains: [{
                type: 'Person',
            }, {
                type: 'null',
            }],
        },
        sponsors: {
            type: 'array',
            contains: {
                type: 'Sponsor',
            },
            isRequired: true,
        },
        image: {
            type: 'any-of',
            contains: [{
                type: 'Image',
            }, {
                type: 'null',
            }],
        },
        titles: {
            type: 'array',
            contains: {
                type: 'Translation',
            },
            isRequired: true,
        },
        president: {
            type: 'string',
            isRequired: true,
        },
        foundingYear: {
            type: 'string',
            isRequired: true,
        },
        phone: {
            type: 'string',
            isRequired: true,
        },
        mail: {
            type: 'string',
            isRequired: true,
        },
        shopUrl: {
            type: 'string',
            isRequired: true,
        },
        locations: {
            type: 'array',
            contains: {
                type: 'Location',
            },
            isRequired: true,
        },
        facebook: {
            type: 'string',
            isRequired: true,
        },
        instagram: {
            type: 'string',
            isRequired: true,
        },
        lndId: {
            type: 'any-of',
            contains: [{
                type: 'number',
            }, {
                type: 'null',
            }],
        },
        lndPrimaryId: {
            type: 'any-of',
            contains: [{
                type: 'number',
            }, {
                type: 'null',
            }],
        },
        note: {
            type: 'string',
        },
    },
} as const;
